module.exports = __webpack_public_path__ + "img/chat.0e7d8312.png";